import { render, staticRenderFns } from "./LancamentoDeFrequenciaPage.vue?vue&type=template&id=18002747&scoped=true"
import script from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js"
export * from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18002747",
  null
  
)

export default component.exports